<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true">
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="5.5" />
    <circle
      cx="12"
      cy="12"
      r="4.2" />
    <circle
      cx="17.6"
      cy="6.4"
      r="1.2"
      fill="currentColor"
      stroke="none" />
  </svg>
</template>
